import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';

@Component({
  selector: 'app-competence-new',
  templateUrl: './competence-new.component.html',
  styleUrls: ['./competence-new.component.scss']
})
export class CompetenceNewComponent extends BaseForm implements OnInit {

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.auth.checkRightOrRedirect('admin.competence.create')) {
      this.form = this.fb.group({
        name_de: new UntypedFormControl('', [Validators.required]),
        name_en: new UntypedFormControl('', [Validators.required])
      });
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/competences']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('competences', null, this.form.value).subscribe({
        next: (result: any) => {
          const competence = new CompetenceModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: competence.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.router.navigate(['/competences', competence.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
